var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCameraLight = function SvgIconCameraLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_camera_light_svg__a)",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.099 13.17c.867-1.24 2.28-2.17 4.001-2.17H26c1.674 0 3.125.79 4.028 2.21l.013.02L31.72 16h2.78c2.587 0 4.716 2.08 4.6 4.726V32.5c0 2.608-2.093 4.7-4.7 4.7H13.6a4.685 4.685 0 0 1-4.7-4.7V20.7c0-2.607 2.092-4.7 4.7-4.7h2.78l1.68-2.77c.012-.02.025-.041.039-.06Zm1.822 1.233-1.98 3.267a1.1 1.1 0 0 1-.941.53h-3.4a2.485 2.485 0 0 0-2.5 2.5v11.8c0 1.392 1.107 2.5 2.5 2.5h20.8c1.392 0 2.5-1.108 2.5-2.5V20.7l.001-.055c.067-1.34-.997-2.445-2.401-2.445h-3.4a1.1 1.1 0 0 1-.94-.53l-1.994-3.289C27.669 13.606 26.922 13.2 26 13.2h-3.9c-.868 0-1.647.459-2.18 1.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1 21.7a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8ZM18 25.6a6.1 6.1 0 1 1 12.2 0 6.1 6.1 0 0 1-12.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 23.3a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_camera_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 11)",
    d: "M0 0h30.2v26.2H0z"
  })))));
};
export default SvgIconCameraLight;